export default __webpack_public_path__ + "static/media/landjoin.82357c35.svg";